import LogOperations from '@modules/husleie-framework/src/static-classes/LogOperations.class';
import type {
  CommonAPI,
  FeaturesCallback,
  PostalAreasGET,
  ValidationRulesCallback,
  PostalCodeAndPlaceName,
} from '@modules/store/common/types/CommonAPI.interface';
import type Features from '@modules/store/common/types/Features.entity';
import type FetchFeaturesConfig from '@modules/store/common/types/FetchFeaturesConfig.entity';
import type FetchValidationRulesConfig from '@modules/store/common/types/FetchValidationRulesConfig.entity';
import type ValidationRuleEntries from '@modules/store/common/types/ValidationRuleEntries.entity';
import type ValidationRules from '@modules/store/common/types/ValidationRules.entity';
import { merge } from 'lodash';
import './mock_axios/upload';

export default class API implements CommonAPI {
  fetchValidationRules(validationRulesConfig: FetchValidationRulesConfig, callback: ValidationRulesCallback): void {
    const defaultValidationRules: ValidationRuleEntries = {};

    const appValidationRuleEntries: ValidationRuleEntries = validationRulesConfig.loader(validationRulesConfig);
    const validationRuleEntries: ValidationRuleEntries = merge(appValidationRuleEntries, defaultValidationRules);
    const mergedValidationRules: ValidationRules = { rules: validationRuleEntries };

    LogOperations.debug('MOCK fetchValidationRules', mergedValidationRules);

    callback(mergedValidationRules);
  }

  fetchFeatures(featuresConfig: FetchFeaturesConfig, callback: FeaturesCallback): void {
    const defaultFeatures: Features = {
      regionToggles: {},
    };

    const appFeatures: Features = featuresConfig.loader();
    const mergedFeatures: Features = merge(appFeatures, defaultFeatures);

    LogOperations.debug('MOCK fetchFeatures', mergedFeatures);

    callback(mergedFeatures);
  }

  // eslint-disable-next-line no-unused-vars
  fetchPostalAreasByPostalCode(get: PostalAreasGET): Promise<PostalCodeAndPlaceName[]> {
    LogOperations.debug('MOCK fetchPostalAreasByPostalCode');

    const list: PostalCodeAndPlaceName[] = [
      { postalCode: get.postalCode, placeName: 'Mock municipality 1' },
      { postalCode: get.postalCode, placeName: 'Mock municipality 2' },
      { postalCode: get.postalCode, placeName: 'Mock municipality 3' },
      { postalCode: get.postalCode, placeName: 'Mock municipality 4' },
      { postalCode: get.postalCode, placeName: 'Mock municipality 5' },
      { postalCode: get.postalCode, placeName: 'Mock municipality 6' },
      { postalCode: get.postalCode, placeName: 'Mock municipality 7' },
      { postalCode: get.postalCode, placeName: 'Mock municipality 8' },
      { postalCode: get.postalCode, placeName: 'Mock municipality 9' },
      { postalCode: get.postalCode, placeName: 'Mock municipality 10' },
      { postalCode: get.postalCode, placeName: 'Mock municipality 11' },
    ];

    return new Promise(resolve => {
      resolve(list);
    });
  }

  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  fetchCheckEmailInUse(email: string): Promise<boolean> {
    LogOperations.debug('MOCK fetchCheckEmailInUse');

    return new Promise(resolve => {
      resolve(false);
    });
  }

  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  verifyCellPhoneSend(cellPhone: string): Promise<string> {
    LogOperations.debug('MOCK verifyCellPhoneSend');

    return Promise.resolve('TEST');
  }

  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  verifyCellPhoneVerify(cellPhone: string, token: string, code: string): Promise<boolean> {
    LogOperations.debug('MOCK verifyCellPhoneVerify');

    return Promise.resolve(false);
  }
}
